import Tooltip from "./Tooltip";
import {Badge} from "react-bootstrap";
import React from "react";

export function BadgeTooltip(props) {
    return <Tooltip tooltip={props.tooltip}>
        <Badge className={"badge-primary-outline " + props.className}>{props.children}</Badge>
    </Tooltip>;
}